<template>
  <div class="print-cover-container first-page">
    <div class="print-margin d-flex flex-column align-items-center">
      <h1 class="print-name text-center mb-0 w-100" :style="nameStyle">
        <span v-if="lang === 'KOR'">
          {{ selected_report?.report_name_e }}
        </span>
        <span v-else>
          {{ selected_report?.report_name }}
        </span>
      </h1>
      <h2 class="print-subname text-center mb-2" :style="subnameStyle">
        <span v-if="lang === 'KOR'">
          {{ selected_report?.report_name }}
        </span>
        <span v-else>
          {{ selected_report?.report_name_e }}
        </span>
      </h2>
      <p class="print-date text-center gray-600">
        {{ selected_report.start_date }} ~ {{ selected_report.end_date }}
      </p>
    </div>

    <div v-if="theme_option" class="overlay print-margin-sub" :style="backgroundImageStyle"></div>

    <div class="d-flex justify-content-center align-items-end">
      <b-img :src="$store.state.static_host + selected_report.logo_path" class="pdf-cover-logo" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'PdfMain',
  components: {},
  props: {
    mp4Url: { type: String, default: null },
    imageUrl: { type: String, default: null }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('report_list', ['lang']),
    ...mapGetters('report_list', ['selected_report']),
    ...mapState('report_contents', ['theme_option']),
    nameStyle() {
      if (this.theme_option?.theme_info && this.selected_report) {
        return {
          fontFamily: `${this.theme_option?.theme_info?.title_font}`,
          color: `${this.selected_report.main_color}`
        };
      } else {
        return null;
      }
    },

    subnameStyle() {
      if (this.theme_option?.theme_info && this.selected_report) {
        return {
          fontFamily: `${this.theme_option?.theme_info?.title_font}`,
          color: `${this.selected_report.main_color}`
        };
      } else {
        return null;
      }
    },

    backgroundImageStyle() {
      if (this.mp4Url) {
        return {
          background: `url(${this.mp4Url}) center center / cover no-repeat`,
          maxHeight: '700px'
        };
      } else if (this.imageUrl) {
        return {
          background: `url(${this.imageUrl}) center center / cover no-repeat`,
          maxHeight: '700px'
        };
      } else {
        return {
          backgroundColor: this.selected_report?.main_color,
          minHeight: 'auto',
          width: '100%',
          maxHeight: '700px'
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.print-cover-container {
  position: relative;
  padding-top: 100px;
  padding-bottom: 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: space-between;
  height: 100vh;
}

.print-subname {
  font-size: 2rem;
  font-weight: 500;
  line-height: 1.4;
}

.print-name {
  font-size: 2.75rem;
  font-weight: 700;
  line-height: 1.4;
}

.print-date {
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.4;
}

.pdf-cover-logo {
  width: 175px;
}
.overlay {
  min-height: 700px;
  background-position: center center;
  background-repeat: no-repeat;
  background-origin: border-box;
  background-size: cover;
}
</style>
